import comp from "./Tag";
export default comp;
